import React, { type MouseEvent } from 'react';
import cn from 'classnames';
import _upperFirst from 'lodash/upperFirst';

import { getLayerTypeIcon } from 'helpers/getLayerTypeIcon';

import { Typography } from 'components/shared/Typography';
import { Icon } from 'components/shared/Icon';

import {
  getLayerTypeIconClassName,
  getLayerSubType,
  getLayerCheck,
} from './Layer.helpers';

import styles from './Layer.module.scss';

type LayerData = Record<string, unknown>;

type LayerProps = {
  open?: boolean;
  current?: boolean;
  hasChildren?: boolean;
  namePrefix: string;
  layer: LayerData;
  level: number;
  onArrowClick?: (e: MouseEvent) => void;
  onClick: (event: MouseEvent, namePrefix: string, layer: LayerData) => void;
};

const Layer = ({
  open,
  current,
  hasChildren,
  namePrefix,
  layer,
  level,
  onArrowClick,
  onClick,
}: LayerProps) => {
  const TypeIconRaw = getLayerTypeIcon(
    layer.type as string,
    getLayerSubType(layer),
  );
  const TypeIconComponent = TypeIconRaw as unknown as React.ComponentType<{
    className?: string;
  }>;

  const typeIconClassName = getLayerTypeIconClassName(layer);

  return (
    <div
      className={cn(styles.layer, { [styles.layerCurrent]: current })}
      style={{ paddingLeft: `${8 + level * 30}px` }}
      onClick={(event: any) => onClick(event, namePrefix, layer)}
    >
      <div className={styles.inner}>
        <TypeIconComponent
          className={cn(
            styles.typeIcon,
            styles[`typeIcon${_upperFirst(typeIconClassName)}`],
          )}
        />
        <Typography
          className={cn(
            styles.name,
            styles[`name${_upperFirst(typeIconClassName)}`],
          )}
          variant="body2"
          weight="medium"
          mode="compact"
        >
          {layer.name as string}
        </Typography>
      </div>
      <div className={styles.info}>
        {getLayerCheck(layer) && <div className={styles.checkCircle} />}
        {hasChildren && (
          <Icon
            className={cn(styles.icon, { [styles.iconOpen]: open })}
            name="chevronDown"
            onClick={onArrowClick}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(Layer);
